export const selectedParkingMarkerSelector = ({selectedParkingMarker}) => selectedParkingMarker